import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const ModalComponent = ({
  open,
  title,
  message,
  primaryAction,
  secondaryAction,
  primaryText,
  secondaryText,
  handleClosePopup,
  children,
  modalSize = "md",
  hideFooter = false,
}) => {
  return (
    <div className="basic-modal">
      <Modal
        className="modal-primary"
        size={modalSize}
        isOpen={open}
        toggle={handleClosePopup}
      >
        <ModalHeader toggle={handleClosePopup}>{title}</ModalHeader>

        <ModalBody>
          {message && <p style={{ marginTop: 11 }}> {message} </p>}

          {children && <>{children}</>}
        </ModalBody>
        {!hideFooter && (
          <ModalFooter>
            {secondaryText && (
              <Button color="outline-primary" onClick={secondaryAction}>
                {secondaryText}
              </Button>
            )}

            {primaryText && (
              <Button color="primary" onClick={primaryAction}>
                {primaryText}
              </Button>
            )}
          </ModalFooter>
        )}
      </Modal>
    </div>
  );
};

export default ModalComponent;
